module.exports = __webpack_public_path__ + "static/assets/0194194548ab694b94c7f3b45fe8aaec.svg";